import { Currency } from '../../../../enums';
import { getCurrency } from '../../../../cache';
import { Money } from '../../../../types';

export const getZeroPrice = (currency?: string): Money => {
	const zeroPrice: Money = {
		amount: 0,
		currency: getCurrency()
	};

	if (currency in Currency) {
		zeroPrice.currency = currency as Currency;
	}

	return zeroPrice;
};
